import React, {
  useEffect,
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import DupontDatePicker from "../DatePopover/DupontDatePicker";
import moment from "moment";
const DateTimeCellEditor = forwardRef((props, ref) => {
  const {
    value,
    stopEditing,
    onChange: onChangeProp,
    cellEditorParams: cellEditorParamsFromCaller = {},
    column = {},
    ...rest
  } = props;
  const cellEditorParams = {
    dateFormat: "yyyy-MM-dd HH:mm",
    showTimeSelect: true,
    timeIntervals: 15,
    timeFormat: "HH:mm",
    showMonthDropdown: true,
    showYearDropdown: true,
    dropdownMode: "select",
    ...((column && column.cellEditorParams) || {}),
    ...cellEditorParamsFromCaller,
  };
  const {
    dateFormat,
    showTimeSelect,
    timeIntervals,
    timeFormat,
    minDate,
    maxDate,
    ...otherPickerProps
  } = cellEditorParams;
  const [selectedDate, setSelectedDate] = useState(
    value ? new Date(value) : new Date()
  );
  const inputRef = useRef();
  useEffect(() => {
    setTimeout(() => {
      inputRef.current?.focus?.();
    });
  }, []);
  useImperativeHandle(ref, () => ({
    getValue: () =>
      selectedDate ? moment(selectedDate).format("YYYY-MM-DD HH:mm:ss") : "",
  }));
  const onChange = (date) => {
    setSelectedDate(date);
    if (onChangeProp) onChangeProp(date);
  };
  const onCalendarClose = () => {
    stopEditing();
  };
  return (
    <div style={{ position: "relative", zIndex: 1000 }}>
      <DupontDatePicker
        selected={selectedDate}
        onChange={onChange}
        onCalendarClose={onCalendarClose}
        showTimeSelect={showTimeSelect}
        timeFormat={timeFormat}
        timeIntervals={timeIntervals}
        dateFormat={dateFormat}
        minDate={minDate}
        maxDate={maxDate}
        className={"custom-input-cecs"}
        placeholderText="Select date and time"
        portalId="dupont-datepicker-portal"
        popperPlacement="bottom-start"
        popperClassName="dupont-datepicker-popper"
        {...otherPickerProps}
        {...rest}
      />
    </div>
  );
});
export default DateTimeCellEditor;
